<template>
    <div class="loginbg" id="login-main-hr">
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img :src="logoPath" alt="Velocity Vehicle Group">
                        </div>
                        <form>
                            <div class="form-group">
                                <label for="exampleInputEmail1">CCAuthFormId: {{ ccauthFormId }}</label>
                                <span class="help is-danger">{{username_error_msg}}</span>
                            </div>

                            <div class="form-group">
                                <label for="exampleInputPassword1">Password</label>
                                <input v-model="password" type="password" name="password" class="form-control" id="password_login" placeholder="Enter password">
                                <span class="help is-danger">{{password_error_msg}}</span>
                            </div>

                            <div class="help is-danger">{{error_msg_login}}</div>
                            <button :disabled="disableButtons.loginButton" id="loginbtn" type="submit" class="btn btn-primary" v-on:click.prevent="login(this)">{{buttonNames.loginButton}}</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import Vue from 'vue';
    import {HTTP} from '../../http-common';
    // import EventBus from '.././event-bus';
    import {
        commonMixins
    } from '../../mixins/commonMixins';
    var self;

    export default {
        name: 'Customer',
        mixins: [commonMixins],
        data() {
            return {
                ccauthFormId: "",
                password: "",
                not_registered_url: "",
                forgot_pass_url: "",
                username_error_msg: "",
                password_error_msg: "",
                buttonNames : {
                    loginButton : 'Verify',
                },
                disableButtons : {
                    loginButton : false,
                },
                error_msg_login: "",
                logoPath:'',
            }
        },
        created: function () {
        },
        beforeMount: function () {
            self = this;
            self.logoPath = process.env.LOGO_FILE_PATH;
        },
        mounted: function () {
            if(this.$route.query.id) {
              self.ccauthFormId = this.$route.query.id;
            }

            if(this.$route.query.internal) {
                var is_login = localStorage.getItem('is_login');

                if(is_login == 1) {
                    localStorage.setItem("ccauthFormId", self.ccauthFormId);
                    localStorage.setItem("showCustomerForm", '1');
                    localStorage.setItem("isInternal", '1');
                    window.location.href = "/form/detail/internal";
                }
            }

            $('#main-header').hide();
            $('#sidebar-wrapper').hide();
            $("#wrapper").addClass("login-div-full");
            $(".loginbg").show();
        },
        methods: {
            login: function() {
                var error = false;
                self.username_error_msg = '';
                self.password_error_msg = '';

                if(!self.ccauthFormId || self.ccauthFormId == null || self.ccauthFormId == "") {
                    self.username_error_msg = "The CCAuthFormId is missing.";
                    error = true;
                }

                if(!self.password || self.password == null || self.password == "") {
                    self.password_error_msg = "The password field is required.";
                    error = true;
                }

                if(!error) {
                  self.buttonNames.loginButton = "Verifying...";
                  self.disableButtons.loginButton = true;

                  var fields = {
                      ccauthFormId: self.ccauthFormId,
                      password: self.password
                  };

                  HTTP.post("verify/password", fields)
                      .then(function (data) {
                        console.log(data);
                          self.buttonNames.loginButton = "Verify";
                          self.disableButtons.loginButton = false;
                          /*$('#loginbtn').text("Login");
                          $("#loginbtn").attr("disabled", false);*/

                          if (data.status == 200) {
                              // localStorage.setItem("is_login", data.data.content.result);
                              localStorage.setItem("ccauthFormId", self.ccauthFormId);
                              localStorage.setItem("showCustomerForm", '1');
                              window.location.href = "/form/detail";
                          }
                          if (data.status == 201) {
                              self.error_msg_login = data.data.content;
                          }
                      })
                      .catch(function (error) {
                          self.error_msg_login = "";
                          self.buttonNames.loginButton = "Verify";
                          self.disableButtons.loginButton = false;
                          /*$('#loginbtn').text("Login");
                          $("#loginbtn").attr("disabled", false);*/
                          if (error.response.status == 0) {
                              self.error_msg_login = "Remote server can not be reachable";
                          } else {
                              if (error.response.data.message) {
                                  self.error_msg_login = error.response.data.message;
                              }
                          }
                      })
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Login/VerifyCCAuthForm.vue